import * as Sentry from "@sentry/react";
import { IFinixTokenizationErrorDetails } from "components/FinixPaymentForm/finixTokenizationError";

interface IReportFinixTokenizationFailureArgs {
  orderId: string;
  /** The text the patient was shown. */
  message: string;
  /** Present when finix.js itself failed; already whitelisted (no card data). */
  details?: IFinixTokenizationErrorDetails;
  flow: "single_card" | "split";
  cardIndex?: 1 | 2;
}

// Pay pressed, card never reached our backend. Only whitelisted fields from
// parseFinixTokenizationError (status, message, code, logref, field names) go to Sentry —
// never the raw finix.js objects, which echo the request.
export const reportFinixTokenizationFailure = ({
  orderId,
  message,
  details,
  flow,
  cardIndex,
}: IReportFinixTokenizationFailureArgs) => {
  Sentry.captureMessage("Finix card tokenization failed", {
    level: "error",
    tags: { operation: "finix_tokenization_frontend", orderId, flow },
    extra: {
      orderId,
      errorMessage: message,
      ...(cardIndex ? { cardIndex } : {}),
      ...(details?.sentryExtra ?? {}),
    },
  });
};
